function appendPageToMetaTitle(metaTitle, intl, page) {
  if (page && intl.messages['Global.Page']) {
    const pageText = intl.formatMessage({ id: 'Global.Page' }, { page });
    return `${pageText} ${metaTitle}`;
  }
  return metaTitle;
}

export default appendPageToMetaTitle;
